'use strict'

module.exports = {
  MAX_PRIORITY : 100,
};
